import { SiteBranding } from '../types';

const SITE_BRANDING_STORAGE_KEY = 'chc_site_branding_v1';

export const DEFAULT_SITE_BRANDING: SiteBranding = {
  logoUrl: '',
  logoUrlDark: '',
  faviconUrl: '',
  logoType: 'default',
  companyName: 'CHERIF HADDAD',
  headerTagline: 'Improving the Power of Your Company',
  headerSubtitle: 'Consulting • Audit • Expertise • Training • Certification',
  headerPhone: '+213 (0)661 88 07 52',
  headerEmail: 'contact@cherifhaddad.com',
  topBannerText: 'Improving the Power of Your Company | Consulting • Audit • Expertise • Training • Certification',
  showTopBanner: true,
  citiesList: 'Paris • Alger • Tunis • Dubai',
  footerCopyright: '© {year} Cherif Haddad Consulting & Expertise. Tous droits réservés. Système d\'audit & de certification accrédité.',
  footerAboutText: 'Cabinet international d\'ingénierie-conseil, d\'audit qualité & sécurité, d\'expertise maritime et de formations de haut niveau. Partenaire stratégique des industries exigeantes en Europe, au Maghreb et au Moyen-Orient.',
  heroTitle: '',
  heroSubtitle: '',
  aboutTitle: '',
  aboutText: '',
  accentColor: 'cyan',
  addressParis: 'Paris (8e) - 8 Place Vendôme, 75001 Paris, France',
  addressAlger: 'Alger (Hydra) - Centre d\'Affaires El Qods, Chéraga, Alger',
  addressDubai: 'Dubai (DIFC) - Gate Precinct 4, Level 5, DIFC, UAE',
  socialLinkedin: 'https://www.linkedin.com',
  socialTwitter: 'https://twitter.com',
  socialFacebook: 'https://facebook.com',
  showEmergencyBanner: true,
  lastUpdated: new Date().toISOString(),
};

/**
 * Get current site branding from localStorage or fallback to defaults
 */
export function getSiteBranding(): SiteBranding {
  if (typeof window === 'undefined') return DEFAULT_SITE_BRANDING;
  try {
    const raw = localStorage.getItem(SITE_BRANDING_STORAGE_KEY);
    if (!raw) return DEFAULT_SITE_BRANDING;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_SITE_BRANDING, ...parsed };
  } catch (error) {
    console.error('Failed to parse site branding from storage:', error);
    return DEFAULT_SITE_BRANDING;
  }
}

/**
 * Save site branding and trigger broadcast event
 */
export function saveSiteBranding(updated: Partial<SiteBranding>): SiteBranding {
  const current = getSiteBranding();
  const next: SiteBranding = {
    ...current,
    ...updated,
    lastUpdated: new Date().toISOString(),
  };

  try {
    localStorage.setItem(SITE_BRANDING_STORAGE_KEY, JSON.stringify(next));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('chc_site_branding_updated', { detail: next }));
    }
  } catch (error) {
    console.error('Failed to save site branding:', error);
  }

  return next;
}

/**
 * Reset site branding back to factory defaults
 */
export function resetSiteBranding(): SiteBranding {
  try {
    localStorage.removeItem(SITE_BRANDING_STORAGE_KEY);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('chc_site_branding_updated', { detail: DEFAULT_SITE_BRANDING }));
    }
  } catch (error) {
    console.error('Failed to reset site branding:', error);
  }
  return DEFAULT_SITE_BRANDING;
}
